export default {
  computed: {
    branchQuery() {
      const id = this.$route.query.branchId;
      if (!id) return {};
      const n = Number(id);
      return Number.isNaN(n) ? {} : { branchId: n };
    }
  }
};
